
document.getElementById('mc-embedded-subscribe-form').reset();

const inputEmail = document.getElementById('mce-EMAIL');
const submit = document.getElementById('submitButton')
const checkbox = document.getElementById('checkbox')

submit.setAttribute("disabled", "true");

let checkboxValidated = false
let nameValidated = true
let emailValidated = false

// EVENT LISTENERS
document.addEventListener('DOMContentLoaded', () => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    const emailParam = params.email;
    if(emailParam){
        inputEmail.value = window.atob(emailParam)
        validateEmail(inputEmail.value)
    }
});

inputEmail.addEventListener("change", (event) => {
    validateEmail(event.target.value)
});

checkbox.addEventListener("change", (event) => {
    validateCheckbox(event.target)
});

submit.addEventListener("click", (event) => {
    setTimeout(() => {
        document.getElementById('mc-embedded-subscribe-form').reset();
    }, "1000")
});

function submitCheck() {
    console.log(nameValidated, emailValidated, checkboxValidated)
    if (nameValidated && emailValidated && checkboxValidated) {
      //submit.disabled = false;              //button is no longer no-clickable
      submit.removeAttribute("disabled");   //detto
    }
}

function validateRegexString(email) {
    return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );     // true|false
}

function validateEmail(value) {
    const iconEmail = document.getElementById('emailCheckIcon')
    const emailParagraph = document.getElementById('emailActionHint')
    if (validateRegexString(value)) {
      // input box color
      inputEmail.classList.remove('is-danger')
      inputEmail.classList.add('is-success')
      // icon type
      iconEmail.classList.remove('fa-exclamation-triangle')
      iconEmail.classList.add('fa-check')
      emailParagraph.style = 'display:none'
   
      emailValidated = true
      submitCheck()
    } else {
      // input box color
      inputEmail.classList.remove('is-success')
      inputEmail.classList.add('is-danger')
      // icon type
      iconEmail.classList.remove('fa-check')
      iconEmail.classList.add('fa-exclamation-triangle')
      emailParagraph.style = 'display:block'
   
      emailValidated = false
      submit.setAttribute("disabled", "true");
    }
}

function validateCheckbox(checkbox) {
    //console.log(checkbox)
    if(checkbox.checked){
        checkboxValidated = true
    } else {
        checkboxValidated = false
        submit.setAttribute("disabled", "true");
    }
    submitCheck()
}
